import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["disabled"];

var _ue;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import U, { Fragment as G, createContext as j, createRef as B, useContext as Q, useEffect as W, useMemo as v, useReducer as V, useRef as _ } from "react";
import { match as K } from "../../utils/match.js";
import { forwardRefWithAs as h, render as P, Features as H } from "../../utils/render.js";
import { disposables as E } from "../../utils/disposables.js";
import { useDisposables as N } from "../../hooks/use-disposables.js";
import { useIsoMorphicEffect as x } from "../../hooks/use-iso-morphic-effect.js";
import { useSyncRefs as D } from "../../hooks/use-sync-refs.js";
import { useId as F } from "../../hooks/use-id.js";
import { Keys as d } from "../keyboard.js";
import { Focus as I, calculateActiveIndex as $ } from "../../utils/calculate-active-index.js";
import { isDisabledReactIssue7711 as q } from "../../utils/bugs.js";
import { isFocusableElement as J, FocusableMode as z, sortByDomNode as X } from "../../utils/focus-management.js";
import { useOutsideClick as Y } from "../../hooks/use-outside-click.js";
import { useTreeWalker as Z } from "../../hooks/use-tree-walker.js";
import { useOpenClosed as ee, State as L, OpenClosedProvider as te } from "../../internal/open-closed.js";
import { useResolveButtonType as re } from "../../hooks/use-resolve-button-type.js";
import { useOwnerDocument as ne } from "../../hooks/use-owner.js";
import { useEvent as y } from "../../hooks/use-event.js";

var oe = function (o) {
  return o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o;
}(oe || {}),
    ae = function (o) {
  return o[o.Pointer = 0] = "Pointer", o[o.Other = 1] = "Other", o;
}(ae || {}),
    ie = function (a) {
  return a[a.OpenMenu = 0] = "OpenMenu", a[a.CloseMenu = 1] = "CloseMenu", a[a.GoToItem = 2] = "GoToItem", a[a.Search = 3] = "Search", a[a.ClearSearch = 4] = "ClearSearch", a[a.RegisterItem = 5] = "RegisterItem", a[a.UnregisterItem = 6] = "UnregisterItem", a;
}(ie || {});

function k(t) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (o) {
    return o;
  };
  var o = t.activeItemIndex !== null ? t.items[t.activeItemIndex] : null,
      e = X(i(t.items.slice()), function (u) {
    return u.dataRef.current.domRef.current;
  }),
      n = o ? e.indexOf(o) : null;
  return n === -1 && (n = null), {
    items: e,
    activeItemIndex: n
  };
}

var ue = (_ue = {}, _defineProperty(_ue, 1, function _(t) {
  return t.menuState === 1 ? t : _objectSpread(_objectSpread({}, t), {}, {
    activeItemIndex: null,
    menuState: 1
  });
}), _defineProperty(_ue, 0, function _(t) {
  return t.menuState === 0 ? t : _objectSpread(_objectSpread({}, t), {}, {
    menuState: 0
  });
}), _defineProperty(_ue, 2, function _(t, i) {
  var n;
  var o = k(t),
      e = $(i, {
    resolveItems: function resolveItems() {
      return o.items;
    },
    resolveActiveIndex: function resolveActiveIndex() {
      return o.activeItemIndex;
    },
    resolveId: function resolveId(u) {
      return u.id;
    },
    resolveDisabled: function resolveDisabled(u) {
      return u.dataRef.current.disabled;
    }
  });
  return _objectSpread(_objectSpread(_objectSpread({}, t), o), {}, {
    searchQuery: "",
    activeItemIndex: e,
    activationTrigger: (n = i.trigger) != null ? n : 1
  });
}), _defineProperty(_ue, 3, function _(t, i) {
  var e = t.searchQuery !== "" ? 0 : 1,
      n = t.searchQuery + i.value.toLowerCase(),
      s = (t.activeItemIndex !== null ? t.items.slice(t.activeItemIndex + e).concat(t.items.slice(0, t.activeItemIndex + e)) : t.items).find(function (c) {
    var p;
    return ((p = c.dataRef.current.textValue) == null ? void 0 : p.startsWith(n)) && !c.dataRef.current.disabled;
  }),
      a = s ? t.items.indexOf(s) : -1;
  return a === -1 || a === t.activeItemIndex ? _objectSpread(_objectSpread({}, t), {}, {
    searchQuery: n
  }) : _objectSpread(_objectSpread({}, t), {}, {
    searchQuery: n,
    activeItemIndex: a,
    activationTrigger: 1
  });
}), _defineProperty(_ue, 4, function _(t) {
  return t.searchQuery === "" ? t : _objectSpread(_objectSpread({}, t), {}, {
    searchQuery: "",
    searchActiveItemIndex: null
  });
}), _defineProperty(_ue, 5, function _(t, i) {
  var o = k(t, function (e) {
    return [].concat(_toConsumableArray(e), [{
      id: i.id,
      dataRef: i.dataRef
    }]);
  });
  return _objectSpread(_objectSpread({}, t), o);
}), _defineProperty(_ue, 6, function _(t, i) {
  var o = k(t, function (e) {
    var n = e.findIndex(function (u) {
      return u.id === i.id;
    });
    return n !== -1 && e.splice(n, 1), e;
  });
  return _objectSpread(_objectSpread(_objectSpread({}, t), o), {}, {
    activationTrigger: 1
  });
}), _ue),
    w = j(null);
w.displayName = "MenuContext";

function C(t) {
  var i = Q(w);

  if (i === null) {
    var o = new Error("<".concat(t, " /> is missing a parent <Menu /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(o, C), o;
  }

  return i;
}

function se(t, i) {
  return K(i.type, ue, t, i);
}

var le = G,
    ce = h(function (i, o) {
  var _K;

  var e = V(se, {
    menuState: 1,
    buttonRef: B(),
    itemsRef: B(),
    items: [],
    searchQuery: "",
    activeItemIndex: null,
    activationTrigger: 1
  }),
      _e = _slicedToArray(e, 2),
      _e$ = _e[0],
      n = _e$.menuState,
      u = _e$.itemsRef,
      s = _e$.buttonRef,
      a = _e[1],
      c = D(o);

  Y([s, u], function (M, R) {
    var T;
    n === 0 && (a({
      type: 1
    }), J(R, z.Loose) || (M.preventDefault(), (T = s.current) == null || T.focus()));
  });
  var p = v(function () {
    return {
      open: n === 0
    };
  }, [n]),
      g = i,
      f = {
    ref: c
  };
  return U.createElement(w.Provider, {
    value: e
  }, U.createElement(te, {
    value: K(n, (_K = {}, _defineProperty(_K, 0, L.Open), _defineProperty(_K, 1, L.Closed), _K))
  }, P({
    ourProps: f,
    theirProps: g,
    slot: p,
    defaultTag: le,
    name: "Menu"
  })));
}),
    pe = "button",
    de = h(function (i, o) {
  var T;

  var _C = C("Menu.Button"),
      _C2 = _slicedToArray(_C, 2),
      e = _C2[0],
      n = _C2[1],
      u = D(e.buttonRef, o),
      s = "headlessui-menu-button-".concat(F()),
      a = N(),
      c = y(function (l) {
    switch (l.key) {
      case d.Space:
      case d.Enter:
      case d.ArrowDown:
        l.preventDefault(), l.stopPropagation(), n({
          type: 0
        }), a.nextFrame(function () {
          return n({
            type: 2,
            focus: I.First
          });
        });
        break;

      case d.ArrowUp:
        l.preventDefault(), l.stopPropagation(), n({
          type: 0
        }), a.nextFrame(function () {
          return n({
            type: 2,
            focus: I.Last
          });
        });
        break;
    }
  }),
      p = y(function (l) {
    switch (l.key) {
      case d.Space:
        l.preventDefault();
        break;
    }
  }),
      g = y(function (l) {
    if (q(l.currentTarget)) return l.preventDefault();
    i.disabled || (e.menuState === 0 ? (n({
      type: 1
    }), a.nextFrame(function () {
      var b;
      return (b = e.buttonRef.current) == null ? void 0 : b.focus({
        preventScroll: !0
      });
    })) : (l.preventDefault(), l.stopPropagation(), n({
      type: 0
    })));
  }),
      f = v(function () {
    return {
      open: e.menuState === 0
    };
  }, [e]),
      M = i,
      R = {
    ref: u,
    id: s,
    type: re(i, e.buttonRef),
    "aria-haspopup": !0,
    "aria-controls": (T = e.itemsRef.current) == null ? void 0 : T.id,
    "aria-expanded": i.disabled ? void 0 : e.menuState === 0,
    onKeyDown: c,
    onKeyUp: p,
    onClick: g
  };

  return P({
    ourProps: R,
    theirProps: M,
    slot: f,
    defaultTag: pe,
    name: "Menu.Button"
  });
}),
    me = "div",
    fe = H.RenderStrategy | H.Static,
    Te = h(function (i, o) {
  var b, O;

  var _C3 = C("Menu.Items"),
      _C4 = _slicedToArray(_C3, 2),
      e = _C4[0],
      n = _C4[1],
      u = D(e.itemsRef, o),
      s = ne(e.itemsRef),
      a = "headlessui-menu-items-".concat(F()),
      c = N(),
      p = ee(),
      g = function () {
    return p !== null ? p === L.Open : e.menuState === 0;
  }();

  W(function () {
    var r = e.itemsRef.current;
    !r || e.menuState === 0 && r !== (s == null ? void 0 : s.activeElement) && r.focus({
      preventScroll: !0
    });
  }, [e.menuState, e.itemsRef, s]), Z({
    container: e.itemsRef.current,
    enabled: e.menuState === 0,
    accept: function accept(r) {
      return r.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : r.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
    },
    walk: function walk(r) {
      r.setAttribute("role", "none");
    }
  });
  var f = y(function (r) {
    var m, S;

    switch (c.dispose(), r.key) {
      case d.Space:
        if (e.searchQuery !== "") return r.preventDefault(), r.stopPropagation(), n({
          type: 3,
          value: r.key
        });

      case d.Enter:
        if (r.preventDefault(), r.stopPropagation(), n({
          type: 1
        }), e.activeItemIndex !== null) {
          var A = e.items[e.activeItemIndex].dataRef;
          (S = (m = A.current) == null ? void 0 : m.domRef.current) == null || S.click();
        }

        E().nextFrame(function () {
          var A;
          return (A = e.buttonRef.current) == null ? void 0 : A.focus({
            preventScroll: !0
          });
        });
        break;

      case d.ArrowDown:
        return r.preventDefault(), r.stopPropagation(), n({
          type: 2,
          focus: I.Next
        });

      case d.ArrowUp:
        return r.preventDefault(), r.stopPropagation(), n({
          type: 2,
          focus: I.Previous
        });

      case d.Home:
      case d.PageUp:
        return r.preventDefault(), r.stopPropagation(), n({
          type: 2,
          focus: I.First
        });

      case d.End:
      case d.PageDown:
        return r.preventDefault(), r.stopPropagation(), n({
          type: 2,
          focus: I.Last
        });

      case d.Escape:
        r.preventDefault(), r.stopPropagation(), n({
          type: 1
        }), E().nextFrame(function () {
          var A;
          return (A = e.buttonRef.current) == null ? void 0 : A.focus({
            preventScroll: !0
          });
        });
        break;

      case d.Tab:
        r.preventDefault(), r.stopPropagation();
        break;

      default:
        r.key.length === 1 && (n({
          type: 3,
          value: r.key
        }), c.setTimeout(function () {
          return n({
            type: 4
          });
        }, 350));
        break;
    }
  }),
      M = y(function (r) {
    switch (r.key) {
      case d.Space:
        r.preventDefault();
        break;
    }
  }),
      R = v(function () {
    return {
      open: e.menuState === 0
    };
  }, [e]),
      T = i,
      l = {
    "aria-activedescendant": e.activeItemIndex === null || (b = e.items[e.activeItemIndex]) == null ? void 0 : b.id,
    "aria-labelledby": (O = e.buttonRef.current) == null ? void 0 : O.id,
    id: a,
    onKeyDown: f,
    onKeyUp: M,
    role: "menu",
    tabIndex: 0,
    ref: u
  };
  return P({
    ourProps: l,
    theirProps: T,
    slot: R,
    defaultTag: me,
    features: fe,
    visible: g,
    name: "Menu.Items"
  });
}),
    Ie = G,
    ye = h(function (i, o) {
  var _i$disabled = i.disabled,
      e = _i$disabled === void 0 ? !1 : _i$disabled,
      n = _objectWithoutProperties(i, _excluded),
      _C5 = C("Menu.Item"),
      _C6 = _slicedToArray(_C5, 2),
      u = _C6[0],
      s = _C6[1],
      a = "headlessui-menu-item-".concat(F()),
      c = u.activeItemIndex !== null ? u.items[u.activeItemIndex].id === a : !1,
      p = _(null),
      g = D(o, p);

  x(function () {
    if (u.menuState !== 0 || !c || u.activationTrigger === 0) return;
    var r = E();
    return r.requestAnimationFrame(function () {
      var m, S;
      (S = (m = p.current) == null ? void 0 : m.scrollIntoView) == null || S.call(m, {
        block: "nearest"
      });
    }), r.dispose;
  }, [p, c, u.menuState, u.activationTrigger, u.activeItemIndex]);

  var f = _({
    disabled: e,
    domRef: p
  });

  x(function () {
    f.current.disabled = e;
  }, [f, e]), x(function () {
    var r, m;
    f.current.textValue = (m = (r = p.current) == null ? void 0 : r.textContent) == null ? void 0 : m.toLowerCase();
  }, [f, p]), x(function () {
    return s({
      type: 5,
      id: a,
      dataRef: f
    }), function () {
      return s({
        type: 6,
        id: a
      });
    };
  }, [f, a]);
  var M = y(function (r) {
    if (e) return r.preventDefault();
    s({
      type: 1
    }), E().nextFrame(function () {
      var m;
      return (m = u.buttonRef.current) == null ? void 0 : m.focus({
        preventScroll: !0
      });
    });
  }),
      R = y(function () {
    if (e) return s({
      type: 2,
      focus: I.Nothing
    });
    s({
      type: 2,
      focus: I.Specific,
      id: a
    });
  }),
      T = y(function () {
    e || c || s({
      type: 2,
      focus: I.Specific,
      id: a,
      trigger: 0
    });
  }),
      l = y(function () {
    e || !c || s({
      type: 2,
      focus: I.Nothing
    });
  }),
      b = v(function () {
    return {
      active: c,
      disabled: e
    };
  }, [c, e]);
  return P({
    ourProps: {
      id: a,
      ref: g,
      role: "menuitem",
      tabIndex: e === !0 ? void 0 : -1,
      "aria-disabled": e === !0 ? !0 : void 0,
      disabled: void 0,
      onClick: M,
      onFocus: R,
      onPointerMove: T,
      onMouseMove: T,
      onPointerLeave: l,
      onMouseLeave: l
    },
    theirProps: n,
    slot: b,
    defaultTag: Ie,
    name: "Menu.Item"
  });
}),
    We = Object.assign(ce, {
  Button: de,
  Items: Te,
  Item: ye
});
export { We as Menu };